<f-data-card class="ih-brief-list">
  <h5>Interaction History</h5>

  <section class="error-wrapper" *ngIf="rootScopeService.activeCustTab.IHBriefViewData.apiFailed == true">
    <section class="error-wrapper">
      <f-alert variant="error">
        <p>
          {{ apiFailureMsg }}
        </p>
      </f-alert>
    </section>
  </section>

<!--Alert for Repeat Contact /Story CCR1-2514 -->

<section class="error-wrapper" *ngIf="rootScopeService.activeCustTab.showRepeatAlertBriefView">
  <section class="error-wrapper">
    <f-alert variant="warning" is-dismissable="true" (alertDismissed)="closeWarning()">
      <p>
       <strong>{{ rootScopeService.getMsgPart1() }}:</strong>  {{ rootScopeService.getMsgPart2()}}
      </p>
    </f-alert>
  </section>
</section>
  <!--End of Alert for Repeat Contact /Story CCR1-2514 -->

  <button mat-button color="primary" title="Refresh" class="btn-refresh hide">
    <i class="fa-solid fa-arrows-rotate"></i>
  </button>


  <!--CCR1-2071-->
  <!-- If no data is returned, this messaged to be displayed. -->
  <p class="empty-state " *ngIf="!rootScopeService.activeCustTab.IHBriefViewData.apiFailed && !rootScopeService.activeCustTab.IHBriefViewData.isDataPresent  ">
    {{errorMsgForIHSentence1()}}<br><br>{{errorMsgForIHSentence2()}}
  </p>
  <!-- If no results meet the filter criteria, display message -->
  <p class="empty-state hide">
    No results meet your criteria.
  </p>

  <ng-container *ngIf="rootScopeService.activeCustTab.IHBriefViewData.isDataPresent">

    <app-alight-table [dataSource]="intHistService.interHistBriefViewTableData" [totalRecords]="totalRecords"
      [gridColumns]="intHistService.Columns" [rowPerPage]="10" (rowSelection)="onRowSelection($event)"
      [hideReplaceAddButton]="false" [isShowButtons]="false" [isPagination]="false" [tableName]="'IHBriefView'" [sortRequired]="false">

    </app-alight-table>

    <f-button [iconConfig]="iconConfig" class="ih-view-btn" text="View all history" title="View all history"
      type="button" variant="action" (click)="goToListViewIHPage($event,false)">
    </f-button>
  </ng-container>

  <app-loader *ngIf="IHBriefViewLoader" [loaderType]="rootScopeService.loaderTypeCard"
    [loaderMsg]="showLoaderMsg"></app-loader>
</f-data-card>